import { Box, chakra } from "@chakra-ui/react";
import React from "react";

export const LevaLogo = (props) => {
  return (
    <Box {...props}>
      <chakra.svg
        width="119"
        height="33"
        viewBox="0 0 119 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <chakra.path
          d="M21.7142 20.6831C18.0625 19.3838 17.3203 17.7964 17.3203 15.6857C17.3203 13.0048 17.6053 10.077 17.6053 7.92517C17.6053 3.69802 15.925 1.79117e-06 11.6973 1.79117e-06C4.26922 -0.00587742 0 14.4629 0 21.6178C0 28.2437 3.20043 33 12.8908 33C18.3119 33 26.5179 30.8835 26.5179 25.2747C26.5179 22.876 24.9147 21.8177 21.7142 20.6831Z"
          fill="black"
        />
        <chakra.path
          d="M52.8125 21.9279C51.1281 21.3503 49.3545 21.0228 49.3545 19.1709C49.3545 17.8966 50.4675 16.539 51.7828 14.9312C53.0565 13.3652 53.9612 11.4716 53.9612 9.41727C53.9612 3.6949 48.4915 1.51552 43.7956 1.47383C33.9692 1.39047 26.5176 8.88136 26.5176 16.5807C26.5176 26.0485 34.7905 31.5267 43.9205 31.5267C47.5809 31.5267 55.6872 29.5081 55.6872 25.1851C55.6931 23.2498 54.7052 22.5889 52.8125 21.9279ZM40.2602 14.4787C39.3139 14.7228 38.5759 14.1095 38.4092 13.3235C37.9569 11.5967 39.2306 9.98892 40.8375 9.57805C41.9922 9.29223 43.5932 9.74478 43.8848 10.894C44.3372 12.6268 41.7005 14.1095 40.2602 14.4787Z"
          fill="black"
        />
        <chakra.path
          d="M62.6301 2.08491C57.6193 2.08491 55.6875 8.94496 55.6875 13.5421C55.6875 20.1943 59.4263 31.5267 67.195 31.5267C69.4954 31.5267 71.7541 30.416 73.6443 29.145C79.8914 24.7914 85.1518 17.0345 85.1518 8.98654C85.1518 5.82675 83.963 1.47314 80.2183 1.47314C75.7781 1.47314 73.561 10.4655 70.1908 10.4655C66.4104 10.4655 67.9321 2.09085 62.6301 2.08491Z"
          fill="black"
        />
        <chakra.path
          d="M115.226 13.7174C112.508 6.04493 109.499 1.17847 104.804 1.17847C95.2873 1.17847 87.7077 13.9639 85.8545 20.2921C85.4434 21.6716 85.1514 23.1333 85.1514 24.6772C85.1514 28.2052 86.8794 31.8213 92.2364 31.8213C97.0154 31.8213 98.1297 28.0878 101.836 28.0878C105.376 28.0878 107.688 31.698 112.794 31.698C115.678 31.698 118.151 29.4263 118.151 26.2211C118.151 23.6147 116.96 18.6249 115.226 13.7174ZM102.581 17.9792C101.222 17.9792 99.9829 17.2102 99.9829 15.907C99.9829 14.4453 101.3 11.3634 102.992 11.3634C104.434 11.3634 104.804 13.9992 104.804 15.7485C104.804 16.8815 104.351 17.9792 102.581 17.9792Z"
          fill="black"
        />
      </chakra.svg>
    </Box>
  );
};
